import { Injectable } from "@angular/core";
import { Municipio } from "src/app/model/municipio";
import { BaseClientService } from "./base-client.service";
import { MunicipioDetaild } from "../../interface/municipio-detaild";

@Injectable({
  providedIn: "root",
})
export class MunicipioService {
  constructor(private client: BaseClientService) {}

  async listMunicipiosPorUf(id: number): Promise<Municipio[]> {
    return await this.client.get(`/municipio/dominio/${id}`).toPromise();
  }

  async getMunicipioByCode(code: string): Promise<MunicipioDetaild | null> {
    // Códigos de município do IBGE são numéricos. Valores indeterminados
    // vindos do CADSUS (ex.: "N/A") contêm "/" e quebram o mapping
    // /municipio/{codigo} (PathPatternParser), gerando 404 no backend.
    if (!code || !/^\d+$/.test(code.trim())) {
      return null;
    }
    return await this.client
      .get<MunicipioDetaild>(`/municipio/${encodeURIComponent(code.trim())}`)
      .toPromise();
  }


}
